<button
	[attr.tooltip-value]="'Back to overlay extent' | translate"
	tooltip-class="bottom left"
	(click)="backToExtent()">
	<span class="indicator" [style.background-color]="color"></span>
	<span class="text">{{'Image is out of bounds' | translate}}</span>
</button>
